var gro = gro || {};

gro.autocomplete = {
	init: function() {

		let $element = $('input.autocomplete');

		if ($element.length) {
			$element.autocomplete({
				minLength: 3,
				source: function(request, response) {
					let $element = $(this.element);
					$.ajax({
						url: $element.data('url'),
						dataType: "json",
						data: {
							query: encodeURIComponent(request.term)
						},
						success: function(data) {
							response(data);
						}
					});
				},
				select: function(event, ui) {
					let $element = $(event.target);
					let namespace = $element.data('namespace');
					let itemSelectLimit = parseInt($element.data('itemselectlimit'));
					let item = ui.item;
					let $results = $element.closest('fieldset').find('ul.autocomplete-results');

					let entryExists = false;
					let total = 0;
					$results.find('input').each(function() {
						if (parseInt($(this).val()) === item.value) {
							entryExists = true;
						}
						total++;
					});

					if (entryExists || (itemSelectLimit > 0 && total >= itemSelectLimit)) {
						return false;
					}

					let $li = $("<li>");
					$li.append('<i class="fa fa-times autocomplete-remove"></i>')
					$li.append('<span>' + item.label + '</span>');
					$li.append($('<input>').attr({
						type: 'hidden',
						name: namespace + 'Id[]',
						value: item.value
					}));
					$results.append($li);

					return false;
				}
			}).autocomplete("instance")._renderItem = function(ul, item) {
				let $li = $("<li>")
				$li.append('<span class="result__label">' + item.label + '</span>');
				$li.wrapInner('<div class="result">').appendTo(ul);

				return $li;
			};

			$('ul.autocomplete-results').on('click', 'i.autocomplete-remove', function() {
				$(this).parent().remove();
			})
		}
	}
};

gro.grid = {
	multiselect: {
		selector: null,
		init: function(selector) {
			gro.grid.multiselect.selector = selector;
			$('.filter-inputs .first .filter-item', selector).remove();
			$('.filter-inputs .first', selector).append('<input type="checkbox" id="gridMultiselectSelectAll" style="width: auto"/>');
			$('.sorter .first', selector).append('Select');
			$(selector).prepend('<input type="hidden" id="gridMultiselectSelected" value="" />');
			$('input.multiselect', selector).on('input', gro.grid.multiselect.onSelect);
			$('#gridMultiselectSelectAll', selector).on('input', gro.grid.multiselect.onSelectAll);
		},
		onSelect: function() {
			var selected = [];
			$('input.multiselect:checked', gro.grid.multiselect.selector).each(function() {
				$input = $(this);
				selected.push($input.val());
			});
			$('#gridMultiselectSelected').val(selected.join(','));

			gro.grid.multiselect.renderModDisplayButton();
		},
		onSelectAll: function() {
			$('input.multiselect', gro.grid.multiselect.selector).each(function() {
				$(this).attr('checked', $('#gridMultiselectSelectAll', gro.grid.multiselect.selector).is(':checked'));
			})
			gro.grid.multiselect.onSelect();
		},
		renderModDisplayButton() {
			var jip = $('#gro .boxTitle .jip');
			var selected = $('#gridMultiselectSelected').val();
			if (selected.length > 1) {
				var $button = $('#gridModDisplayButton', jip);
				if ($button.length < 1) {
					jip.append('<a id="gridModDisplayButton" class="multiselect" href=""><img src="//static.stefna.is/icons/16/Blog_Share.png" alt="icon" class="icon">Modify display settings</a>');
					$button = $('#gridModDisplayButton', jip);
				}

				var baseUrl = '/' + moya.division + '/moya/gro/appearance/modify/person/';
				$button.attr('href', baseUrl + selected);
			} else {
				$('#gridModDisplayButton', jip).remove();
			}
		}
	}
}

gro.filter = {
	$form: undefined,
	currentPage: 1,
	totalItemCount: 0,
	totalPageCount: 0,
	ajaxUrl: $('.loadMore').attr('href'),
	defaultItemCountPerPage: 0,
	init: function() {
		this.$form = $('.filterForm');
		if (gro.filter.$form.length) {
			gro.filter.defaultItemCountPerPage = $('#defaultItemCountPerPage').val();
			let currentPage = $('#currentPage').val();
			if (currentPage !== undefined) {
				gro.filter.currentPage = currentPage;
			}
			let $select = gro.filter.$form.find('select'),
				$text = gro.filter.$form.find('input[type=text]'),
				$submitOnChangeElements = gro.filter.$form.find('select');
			gro.filter.optionHandler();
			$select.change(function() {
				gro.filter.optionHandler();
			});

			$submitOnChangeElements.on('change', gro.filter.triggerSubmit);
			$text.on('keyup', delay(gro.filter.triggerSubmit, 250));
			gro.filter.$form.on('submit', function(e) {
				e.preventDefault();
				const action = gro.filter.$form.attr('action'),
					queryParams = $(this).serialize();
				gro.filter.ajaxUrl = action + '&' + queryParams;
				const queryString = window.location.search;
				const page = (new URLSearchParams(queryString)).get('page');
				if (page) {
					gro.filter.ajaxUrl = gro.filter.ajaxUrl + '&page=' + page;
				}
				gro.filter.performAjaxRequest(e.target.tagName);
			});

			$('.loadMore').on('click', function(e) {
				e.preventDefault();
				gro.filter.performAjaxRequest(e.target.tagName);
			});

			$('.resetFilter').on('click', function() {
				gro.filter.reset();
			});

			function delay(callback, ms) {
				let timer = 0;
				return function() {
					var context = this, args = arguments;
					clearTimeout(timer);
					timer = setTimeout(function() {
						callback.apply(context, args);
					}, ms || 0);
				};
			}

			if ($('.filterResults div').length === 0) {
				gro.filter.setClass('body', 'filter-no-results', true);
			}
			if ($('body').is('.allFellows.fellowOverview')) {
				gro.filter.schoolToggeler();
			}
		}
	},

	optionHandler: function() {
		const $select = gro.filter.$form.find('select');
		$select.each(function() {
			if (parseInt($(this).val()) === -1) {
				$(this).parents('.elm').addClass('hideOption');
			} else {
				$(this).parents('.elm').removeClass('hideOption');
			}
		});
	},

	optionFocusHandler: function() {
		console.log('test');
	},

	reset: function() {
		$('input', gro.filter.$form)
			.not(':button, :submit, :reset, :hidden, .hidden')
			.val('');
		$('select', gro.filter.$form).val('-1');
		// reset page param
		window.history.replaceState(null, null, window.location.pathname);
		gro.filter.$form.trigger('submit');
		gro.filter.optionHandler();
		gro.filter.$form.find('input[type=text]').trigger('blur');
		gro.filter.setClass('body', 'filter-no-more-results', false);
		const id = 'gro';
		const yOffset = -225;
		const element = document.getElementById(id);
		const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
		window.scrollTo({top: y, behavior: 'smooth'});
	},

	triggerSubmit: function(e) {
		// reset page param
		window.history.replaceState(null, null, window.location.pathname);
		if (e.key === 'Enter') {
			e.preventDefault();
			return false;
		} else {
			gro.filter.$form.trigger('submit');
		}
	},

	setClass: function(selector, clsName, isAddClass) {
		let $elem = $(selector);
		if (isAddClass) {
			$elem.addClass(clsName);
		} else {
			$elem.removeClass(clsName);
		}
	},

	setTotalItemCount: function(count) {
		gro.filter.totalItemCount = count;
		$('.resultCount .val').text(function (i, txt) {
			return txt.replace(/\d+/, gro.filter.totalItemCount);
		});
	},

	getCurrentPageSpots: function() {
		return parseInt(gro.filter.defaultItemCountPerPage) * parseInt(gro.filter.currentPage);
	},

	performAjaxRequest: function(callerTagName) {
		let isFilter = false,
			isLoadMore = false;
		switch(callerTagName) {
			case 'FORM':
				isFilter = true;
				break;
			case 'A':
				isLoadMore = true;
				break;
			default:
				return false;
		}

		gro.filter.setClass('body', 'filter-loading', true);
		gro.filter.setClass('body', 'filter-no-results', false);

		let ajaxUrlWithPageNumber = gro.filter.ajaxUrl;
		if (isLoadMore) {
			ajaxUrlWithPageNumber = ajaxUrlWithPageNumber + '&page=' + (parseInt(gro.filter.currentPage) + 1);
		}
		$.ajax({
			dataType: "json",
			url: ajaxUrlWithPageNumber,
			type: 'GET',
			success: function(response) {
				let res = $(response.result);
				let cards = $('.filterResults');

				if (isLoadMore && (gro.filter.currentPage === gro.filter.totalPageCount)) {
					gro.filter.setClass('body', 'filter-loading', false);
					return false;
				}
				gro.filter.currentPage = response.currentPage;
				gro.filter.totalPageCount = response.totalPageCount;
				gro.filter.setTotalItemCount(response.totalItemCount);

				res.first().find('> div').addClass('scale-in-center');
				if (response.totalItemCount) {
					if (isFilter) {
						cards.first().find('> div').addClass('scale-out-center');
					}
					// Check whether all items have been loaded
					if (gro.filter.totalItemCount <= gro.filter.getCurrentPageSpots()) {
						if (gro.filter.totalItemCount <= gro.filter.defaultItemCountPerPage ||
							parseInt(gro.filter.totalPageCount) <= parseInt(gro.filter.currentPage)
						) {
							gro.filter.setClass('body', 'filter-load-more', false);
							gro.filter.setClass('body', 'filter-no-results', true);
							gro.filter.setClass('body', 'filter-no-more-results', true);
						} else {
							gro.filter.setClass('body', 'filter-load-more', false);
						}
					} else {
						if (gro.filter.currentPage === gro.filter.totalPageCount) {
							gro.filter.setClass('body', 'filter-load-more', false);
							gro.filter.setClass('body', 'filter-no-results', true);
							gro.filter.setClass('body', 'filter-no-more-results', true);
						} else {
							gro.filter.setClass('body', 'filter-load-more', true);

						}
					}
					// setTimeout generates a bit smoother transition
					setTimeout(function() {
						gro.filter.setClass('body', 'filter-loading', false);
						if (isFilter) {
							cards.html(res.html());
						} else if (isLoadMore) {
							cards.append(res.html());
						}
					}, 100);
				} else {
					cards.first().find('> div').addClass('scale-out-center');
					setTimeout(function() {
						cards.empty();
						gro.filter.setClass('body', 'filter-loading', false);
						gro.filter.setClass('body', 'filter-no-results', true);
						gro.filter.setClass('body', 'filter-load-more', false);
					}, 300);
				}
				$.ajax({
					url: window.location.href.split(/[?#]/)[0],
					type: 'GET',
					success: function (pagiResponse) {
						let html = $($.parseHTML(pagiResponse));
						let resPaginator = html.find('.paginator');
						let currentPagintor = $('.paginator');
						if (currentPagintor.length === 0) {
							$('.filterResults').after(resPaginator);
						}
						else {
							currentPagintor.replaceWith(resPaginator);
						}
					}
				});
			}
		});

	},
	schoolToggeler: function() {
		let $select = gro.filter.$form.find('#schoolId');
		if ($select.val() > -1) {
			gro.filter.selectSchool(parseInt($select.val()));
		}
		$select.change(function() {
			let $schoolId = parseInt($(this).val());
			gro.filter.hideSchoolRoleSelect();
			if ($schoolId > -1) {
				gro.filter.selectSchool($schoolId);
			}
		});
	},
	hideSchoolRoleSelect: function() {
		let $roleSelects = gro.filter.$form.find('[class*="elm_Role"]');
		$roleSelects.each(function() {
			$(this).removeClass('show');
			$(this).find('select').val([]);

		});
	},
	selectSchool: function($schoolId) {
		let $schoolRole = $('[data-schoolid="' + $schoolId + '"');
		$schoolRole.closest('div.elm').addClass('hideOption');
		$schoolRole.closest('div.elm').addClass('show');
	},
	activityCountryFilter: function () {
		const filterForm = document.querySelector('form.filterForm');
		const categoryInput = filterForm.querySelector('input#category');
		if (categoryInput && categoryInput.getAttribute('value') !== '') {
			const catValue = categoryInput.getAttribute('value');
			const shouldExclude = Boolean(filterForm.querySelector('input#shouldExclude').getAttribute('value'));
			const categoryMap = JSON.parse(filterForm.querySelector('input#countryFilterMap').dataset.activityCategoryMap);
			let countryOptions = filterForm.querySelectorAll('select#countryId option');
			let categoryMapElement = categoryMap[catValue];
			let countryIdsToUse = [];
			if (categoryMapElement) {
				countryIdsToUse = Object.values(categoryMapElement);
			}
			else {
				console.log(categoryMap);
				const codenameMap = JSON.parse(filterForm.querySelector('select#activityType').dataset.codenameMap ?? []);
				codenameMap.forEach(val => {
					countryIdsToUse.push(...Object.values(categoryMap[val])) ;
				})
			}
			console.log(countryIdsToUse)
			if (countryIdsToUse.length > 0) {
				if (!shouldExclude) {
					countryOptions.forEach((option) => {
						if (option.getAttribute('value') !== '-1' && !countryIdsToUse.includes(option.getAttribute('value'))) {
							option.classList.add('hidden');
						}
					})
				}
				else {
					countryOptions.forEach((option) => {
						if (countryIdsToUse.includes(option.getAttribute('value'))) {
							option.classList.add('hidden');
						}
					})
				}
			}
		}
	},
	regionCountryFilter: function () {
		const filterForm = document.querySelector('form.filterForm');
		const regionMap = JSON.parse(filterForm.querySelector('input#regionFilterMap').dataset.countryRegionMap);

		$('.elm_Region select option').each(function() {
			$(this).siblings('[label="'+ this.label +'"]').remove();
		});

		$('#region').on('change', function() {
			const currentRegionLabel = $(':selected', this).attr('label');
			$('#selectedRegions').val(JSON.stringify(regionMap[currentRegionLabel]));
		});
	},
};

gro.linkPublication = {
	init: function() {
		$('select.link-pub').change(function(e) {
			let $this = $(this);
			let url = $this.data('url');
			let publicationId = $this.data('publication');
			let personId = $this.data('person');
			let authorRole = $(this).val();

			$.ajax({
				dataType: "json",
				url: url,
				type: 'POST',
				data: {
					resourceId: publicationId,
					personId: personId,
					classificationId: authorRole
				},
				success: function(response) {
					$this.effect("highlight", {color: '#cec'}, 1500);
				}
			});
		});
	}
}

gro.classificationLink = {
	init: function() {
		$('#classificationParent').change(function() {
			let $this = $(this);
			let $linkSelect = $('#classificationId');
			let url = $this.data('url');
			let parentId = $this.val();
			$.ajax({
				dataType: "json",
				url: url,
				type: 'GET',
				data: {
					parentId: parentId,
				},
				success: function(response) {
					let options = response.options;
					$linkSelect.html(options);
				}
			});
		}).trigger('change');
	}
}

gro.map = {
	init: function() {
		gro.map.initButton();
		gro.map.initAjaxButtons();
	},
	initAjaxButtons: function() {
		if ($('body').attr('data-division') !== 7) {
			const countryCodename = $('.descriptionWrap').attr('data-countrycodename');
			$('.map-nav button').on('click', function() {
				let currentButton = $(this);
				let school = currentButton.attr('data-school');
				let schoolcodename = currentButton.attr('data-schoolcodename');
				$('#countryInfo').addClass('scale-out-center');

				setTimeout(function() {
					$('.map-nav li').removeClass('active');
					currentButton.parent().addClass('active');
					$.ajax({
						url: '/' + schoolcodename + '/moya/gro/map/ajaxcountry',
						data: {
							codename: countryCodename,
							school: school,
							schoolcodename: schoolcodename
						},
						success: function(data) {
							if (data !== '') {
								$('#countryInfo .colWrap').replaceWith(data);
								$('#countryInfo').removeClass('scale-out-center').addClass('scale-in-center');
							}
						}
					});
				}, 500);

			});
		}
	},
	initButton: function() {
		let countryInfo = document.getElementById('countryInfo');
		let button = countryInfo.querySelector('button.close');
		if (button) {
			button.addEventListener('click', () => {
				countryInfo.classList.add('closed');
				countryInfo.innerHTML = '';
			});
		}
	},

}

gro.sort = {
	init: function(url) {
		var $sortList = $('#sortList');
		const publication = $sortList.attr('data-publicationid');
		$sortList.sortable();
		$sortList.on('sortupdate', function() {
			var order = $(this).sortable('toArray').toString();
			$.ajax({
				type: "POST",
				url: url,
				data: {order: order, publication: publication}
			});
		});
	}
}

gro.countryProfile = {
	init: function(section, cardsselector) {
		let loadmoreButton = $(section + ' .loadMoreWrap button')
		let cards = $(cardsselector);
		const totaltems = cards.attr('data-count');
		let visibleCount = parseInt(cards.attr('data-visible'));
		loadmoreButton.on('click', () => {
			visibleCount = visibleCount + visibleCount;
			$(cardsselector + '> div').each(function(index) {
				if (visibleCount > index) {
					$(this).addClass('show');
				}
			});
			if (visibleCount >= totaltems) {
				loadmoreButton.addClass('hidden');
			}
		});
	}
};
